module.exports = __webpack_public_path__ + "static/tarek.f50a30fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tarek.png
// module id = 467
// module chunks = 35783957827783